import { render, staticRenderFns } from "./SoftwareLinksField.vue?vue&type=template&id=61b0db6b&scoped=true"
import script from "./SoftwareLinksField.vue?vue&type=script&lang=js"
export * from "./SoftwareLinksField.vue?vue&type=script&lang=js"
import style0 from "./SoftwareLinksField.vue?vue&type=style&index=0&id=61b0db6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b0db6b",
  null
  
)

export default component.exports